// redux/slices/reviewRequestsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "./resetStore";
import { clearJwtToken } from "../../Utils/authStorage";
import { apiRequest } from "../../Utils/apiClient";
import { patchAppointmentLocal } from "./appointmentsSlice";

/* ========================= Thunks (PRIVATE, с JWT через apiRequest) ========================= */

export const sendReviewNow = createAsyncThunk(
    "reviewRequests/sendReviewNow",
    async ({ appointmentId, uid }, { dispatch, rejectWithValue }) => {
        try {
            if (!appointmentId) throw new Error("ID встречи не передан");

            const response = await apiRequest(
                "POST",
                `/new-appointment/appointment/${appointmentId}/send-review-now`
            );

            if (!response || !response.data) {
                throw new Error("No response data received from server.");
            }

            // локально обновляем встречу, чтобы статус подтянулся без полного рефетча
            const updatedAppointment = response.data?.appointment;
            if (updatedAppointment?.id != null) {
                dispatch(
                    patchAppointmentLocal({
                        id: updatedAppointment.id,
                        changes: updatedAppointment,
                    })
                );
            }

            return response.data;
        } catch (error) {
            const status = error?.response?.status;
            if (status === 401 || status === 403) {
                try { await clearJwtToken(); } catch { }
            }
            return rejectWithValue(
                error?.response?.data || error?.message || "Send review now failed"
            );
        }
    }
);

/* ========================= Slice ========================= */

const initialState = {
    loading: false,
    success: false,
    error: null,
};

const reviewRequestsSlice = createSlice({
    name: "reviewRequests",
    initialState,
    reducers: {
        resetReviewRequestsState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            /* ---------- sendReviewNow ---------- */
            .addCase(sendReviewNow.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(sendReviewNow.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(sendReviewNow.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload || action.error?.message || "sendReviewNow failed";
            })

            /* ---------- reset ---------- */
            .addCase(resetStore, () => initialState);
    },
});

export const { resetReviewRequestsState } = reviewRequestsSlice.actions;
export default reviewRequestsSlice.reducer;